import { Spacing } from '@kezios/design-system';
import { Stack, Text } from '@mantine/core';

export type SectionHeaderProps = {
  category?: string;
  title?: string;
  subtitle?: string;
  variant?: 'left' | 'center';
  titleComponent?: any;
  subtitleComponent?: any;
  fullWidth?: boolean;
};

export const SectionHeader = ({
  category,
  title,
  subtitle,
  variant = 'center',
  titleComponent,
  subtitleComponent,
  fullWidth = false,
}: SectionHeaderProps) => {
  return (
    <Stack
      align={variant === 'left' ? 'flex-start' : 'center'}
      justify="center"
      w={'100%'}
    >
      <Stack
        w={fullWidth ? '100%' : variant === 'left' ? 448 : 768}
        maw={'100%'}
        gap={Spacing.s5}
      >
        <Stack w={'100%'} gap={Spacing.s3}>
          {category && (
            <Text
              style={{ textAlign: variant }}
              variant="textMd.semibold"
              c="primary.7"
            >
              {category}
            </Text>
          )}
          {title && (
            <Text
              style={{ textAlign: variant }}
              variant={`${
                variant === 'left' ? 'displayLg' : 'displayMd'
              }.semibold`}
              c={'gray.9'}
              component={titleComponent}
            >
              {title}
            </Text>
          )}
        </Stack>
        {subtitle && (
          <Text
            style={{ textAlign: variant }}
            variant={variant === 'left' ? 'textLg' : 'textXl'}
            c={'gray.6'}
            component={subtitleComponent}
          >
            {subtitle}
          </Text>
        )}
      </Stack>
    </Stack>
  );
};
